import { Box, Button, Container, Grid2 as Grid, Typography } from "@mui/material"
import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import { Fragment, lazy, Suspense } from "react"
import Images from "../../../../assets/js/Images"

const TopBannerA = lazy(() => import("../../../../components/common/TopBannerA"))
const CtaSection = lazy(() => import("../../../../components/ui/CtaSection"))
const UpcomingWorkshops = lazy(() => import("./UpcomingWorkshops"))
const WorkshopPros = lazy(() => import("./WorkshopPros"))
const Testimonials = lazy(() => import("./Testimonials"))

function Workshop() {

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          heading="Group Workshops"
          currentPage="Group Workshops"
          bannerImg={Images?.groupWorkshop}
        />
      </Suspense>

      <Box
        component="section"
        sx={{ py: { xs: 5, lg: 10 } }}
      >
        <Container maxWidth={false} fixed>
          <Grid container spacing={2}>
            <Grid
              mx="auto"
              textAlign="center"
              size={{ xs: 12, lg: 10, xxl: 8 }}
            >
              <Box
                sx={{
                  mb: 4,
                  gap: 1,
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  color="other.color1"
                  variant="displayLarge"
                >Grow Together in a Supportive Group Setting
                </Typography>
                <Typography
                  color="#7a8a9e"
                  variant="bodyLead"
                >Join interactive workshops with experts and a like-minded community.
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ textAlign: "center" }}>
            <Button
              color="secondary"
              variant="contained"
              sx={{ color: "other.color1" }}
            >Browse Upcoming Workshops
            </Button>
          </Box>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <WorkshopPros />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <UpcomingWorkshops />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Testimonials />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Reserve Your Spot in a Workshop
          </Typography>
          <Button
            variant="CtaButton"
          >Reserve Now
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default Workshop